import styled from 'styled-components'

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${p => p.direction};
  ${p => p.direction === 'column' && 'margin-bottom: 0.8rem;'}

  i {
    font-size: 1.6rem;
  }

  .text {
    font-size: 1.4rem;
  }
`

export default StyledIcon
